import {
  createTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPost,
  CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostResponse,
  CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostData,
  HTTPValidationError,
} from '@common/config/api/client'
import { queryClient } from '@common/config/api/queryClient'
import { queryKeyFactory } from '@features/study_details/Subjects/queryKeyFactory'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

export const useCreateTimepointSubmission = (): UseMutationResult<
  CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostResponse,
  AxiosError<HTTPValidationError>,
  CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostData
> => {
  return useMutation<
    CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostResponse,
    AxiosError<HTTPValidationError>,
    CreateTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPostData
  >({
    mutationFn: async (query) => {
      const response = await createTimepointSubmissionStudiesStudyIdSubjectsSubjectIdTimepointSubmissionPost({
        body: query.body,
        path: query.path,
        throwOnError: true,
      })
      return response.data
    },
    onSuccess: (_, query) => {
      queryClient.invalidateQueries({ queryKey: ['SubjectsList'] })
      queryClient.invalidateQueries({
        queryKey: queryKeyFactory.subjectTimepoints({
          study_id: query.path.study_id,
          subject_id: query.path.subject_id,
        }),
      })
      queryClient.invalidateQueries({ queryKey: ['TimepointExamReassignementCheck'] })
      queryClient.invalidateQueries({ queryKey: ['TimePointsDetails'] })
    },
  })
}
